// extracted by mini-css-extract-plugin
export default {"term-pill":"styles__term-pill--puzjT","term-card":"styles__term-card--Emlg0","expanded":"styles__expanded--7sGV3"};